import { Goerli } from "@usedapp/core";

export const ROUTER_ADDRESS = "0xA738C87784DF54Efa94345feDfCc0e3B9b097EFe";

export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    [Goerli.chainId]: "https://eth-goerli.g.alchemy.com/v2/32Nun9NZYbEcVsuwtSKdURh80_Qiz6mi",
  },
};
